/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateProjectGroupInput = {
    id: string;
    name?: string | null | undefined;
    color?: string | null | undefined;
    statusColumns?: Array<StatusColumnInput | null> | null | undefined;
    sprintTimeBox?: boolean | null | undefined;
    sprintLengthInDays?: number | null | undefined;
    estimationUnit?: string | null | undefined;
    minutesPerEstimationPoint?: number | null | undefined;
    useManualAllocations?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type StatusColumnInput = {
    id?: string | null | undefined;
    name?: string | null | undefined;
    order?: number | null | undefined;
    category?: string | null | undefined;
    projectId?: string | null | undefined;
    projectGroupStatusColumnId?: number | null | undefined;
    autoShowOnTimePage?: boolean | null | undefined;
    encourageTimeRegistration?: boolean | null | undefined;
};
export type updateProjectGroupMutationVariables = {
    input: UpdateProjectGroupInput;
};
export type updateProjectGroupMutationResponse = {
    readonly updateProjectGroup: {
        readonly errors: ReadonlyArray<string | null> | null;
        readonly projectGroup: {
            readonly id: string;
            readonly name: string | null;
            readonly color: string | null;
            readonly projects: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly estimationUnit: string | null;
                        readonly sprintTimeBox: boolean | null;
                        readonly sprintLengthInDays: number | null;
                        readonly minutesPerEstimationPoint: number | null;
                        readonly useManualAllocations: boolean | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type updateProjectGroupMutation = {
    readonly response: updateProjectGroupMutationResponse;
    readonly variables: updateProjectGroupMutationVariables;
};



/*
mutation updateProjectGroupMutation(
  $input: UpdateProjectGroupInput!
) {
  updateProjectGroup(input: $input) {
    errors
    projectGroup {
      id
      name
      color
      projects(first: 100000) {
        edges {
          node {
            id
            estimationUnit
            sprintTimeBox
            sprintLengthInDays
            minutesPerEstimationPoint
            useManualAllocations
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateProjectGroupInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateProjectGroupPayload",
    "kind": "LinkedField",
    "name": "updateProjectGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectGroupType",
        "kind": "LinkedField",
        "name": "projectGroup",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100000
              }
            ],
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "estimationUnit",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sprintTimeBox",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sprintLengthInDays",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minutesPerEstimationPoint",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "useManualAllocations",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "projects(first:100000)"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectGroupMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProjectGroupMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateProjectGroupMutation",
    "operationKind": "mutation",
    "text": "mutation updateProjectGroupMutation(\n  $input: UpdateProjectGroupInput!\n) {\n  updateProjectGroup(input: $input) {\n    errors\n    projectGroup {\n      id\n      name\n      color\n      projects(first: 100000) {\n        edges {\n          node {\n            id\n            estimationUnit\n            sprintTimeBox\n            sprintLengthInDays\n            minutesPerEstimationPoint\n            useManualAllocations\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '02c716b1a27975f942760cac6b1e7951';
export default node;
